// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"83af2024","872":"a6c4077e"}[chunkId] + ".chunk.js";
};